import type { ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';

export const moveToTop = (projectsList: ProjectId[], projectId: ProjectId) => {
	const filteredList = projectsList.filter((id) => id !== projectId);
	return [projectId, ...filteredList];
};

export const moveToBottom = (projectsList: ProjectId[], projectId: ProjectId) => {
	const filteredList = projectsList.filter((id) => id !== projectId);
	return [...filteredList, projectId];
};

export const moveUp = (projectsList: ProjectId[], projectId: ProjectId) => {
	const index = projectsList.indexOf(projectId);
	if (index > 0) {
		const newList = [...projectsList];
		newList.splice(index, 1);
		newList.splice(index - 1, 0, projectId);
		return newList;
	}
	return projectsList;
};

export const moveDown = (projectsList: ProjectId[], projectId: ProjectId) => {
	const index = projectsList.indexOf(projectId);
	if (index >= 0) {
		const newList = [...projectsList];
		newList.splice(index, 1);
		newList.splice(index + 1, 0, projectId);
		return newList;
	}
	return projectsList;
};

export const insertBefore = (
	projectsList: ProjectId[],
	projectId: ProjectId,
	relativeProject: ProjectId,
) => {
	const index = projectsList.indexOf(relativeProject);
	if (index > 0) {
		const newList = [...projectsList];
		newList.splice(index, 0, projectId);
		return newList;
	}
	return projectsList;
};

export const insertAfter = (
	projectsList: ProjectId[],
	projectId: ProjectId,
	relativeProject: ProjectId,
) => {
	const index = projectsList.indexOf(relativeProject);
	if (index >= 0) {
		const newList = [...projectsList];
		newList.splice(index + 1, 0, projectId);
		return newList;
	}
	return projectsList;
};

export const insertAtTop = (projectsList: ProjectId[], projectId: ProjectId) => {
	return [projectId, ...projectsList];
};

export const insertAtBottom = (projectsList: ProjectId[], projectId: ProjectId) => {
	return [...projectsList, projectId];
};
